import React from "react";

const Spinner = () => (
  <div className="spinner spinner-red" role="alert" aria-busy={true}>
    <div className="bounce1"></div>
    <div className="bounce2"></div>
    <div className="bounce3"></div>
  </div>
);

export default Spinner; 
